/**
 * @generated SignedSource<<e55a8c97e3b7f65caeee689ff9b198be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamTeamSchedule_team$data = {
  readonly color: string | null;
  readonly dailySchedule: {
    readonly id: string;
    readonly isActive: boolean;
  };
  readonly id: string;
  readonly monthlySchedule: {
    readonly id: string;
    readonly isActive: boolean;
  };
  readonly weeklySchedule: {
    readonly id: string;
    readonly isActive: boolean;
  };
  readonly " $fragmentType": "TeamTeamSchedule_team";
};
export type TeamTeamSchedule_team$key = {
  readonly " $data"?: TeamTeamSchedule_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamTeamSchedule_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamTeamSchedule_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": "dailySchedule",
      "args": [
        {
          "kind": "Literal",
          "name": "freq",
          "value": "DAILY"
        }
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "currentTeamSchedule(freq:\"DAILY\")"
    },
    {
      "alias": "weeklySchedule",
      "args": [
        {
          "kind": "Literal",
          "name": "freq",
          "value": "WEEKLY"
        }
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "currentTeamSchedule(freq:\"WEEKLY\")"
    },
    {
      "alias": "monthlySchedule",
      "args": [
        {
          "kind": "Literal",
          "name": "freq",
          "value": "MONTHLY"
        }
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "currentTeamSchedule(freq:\"MONTHLY\")"
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "4b5a32e8333d08fd4b15a669fc4526f6";

export default node;
